import React from 'react';

const PlayBtn = () => {
  return (
    <div className="absolute  flex top-0 left-0 right-0 bottom-0 justify-center items-center z-10">
      <span className="flex justify-center items-center p-1 w-[50px] h-[50px] xs:w-[80px] xs:h-[80px]  border xs:border-2 border-solid border-[#fff] rounded-full">
        <svg
          className="w-[30px] h-[30px] xs:w-[40px] xs:h-[40px] mr-[-3px]"
          xmlns="http://www.w3.org/2000/svg"
          width="77"
          height="77"
          fill="#fff"
          viewBox="0 0 24 24"
        >
          <path d="M3 22v-20l18 10-18 10z"></path>
        </svg>
      </span>
    </div>
  );
};

export default PlayBtn;
